import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { UploadedProviderDocumentType, deleteUploadedProviderDocument, updateUploadedProviderDocument, getProviderDocuments } from '@uplift/api';
import { BaseSuspenseQueryOpts } from '../baseTypes';


export const useDeleteUploadedProviderDocumentMutation = (providerId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { documentId: string; reason_for_delete: string }) =>
      deleteUploadedProviderDocument(data.documentId, { reason_for_delete: data.reason_for_delete }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ 'user', providerId, 'documents' ] });
    },
  });
};

export const useUpdateUploadedProviderDocumentMutation = (providerId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { documentId: string; document_type: UploadedProviderDocumentType; description: string }) =>
      updateUploadedProviderDocument(data.documentId, { document_type: data.document_type, description: data.description }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ 'user', providerId, 'documents' ] });
    },
  });
};

export const useProviderDocumentsQuery = (providerId: string, opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: [ 'user', providerId, 'documents' ],
    queryFn: async () => {
      const response = await getProviderDocuments(providerId);

      return response.data;
    },
    ...opts,
  });
};
